import styled, { css } from 'styled-components'
import theme from 'theme_'
import { Font14, Font16, Secondary } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'

export const NetworkStatusWLANsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  width: 100%;
  min-height: 120px;
`

export const NetworkStatusWLANsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const NetworkStatusWLANsHeaderTitle = styled(Secondary)`
  display: flex;
  flex-direction: row;
  color: ${theme.colors.otterWarmBlack};
  ${Font16};
  font-weight: 900;
`

export const NetworkStatusWLANsBody = styled.div`
  display: flex;
  gap: ${theme.spacing.base};
  width: 100%;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
    gap: ${theme.spacing.xs};
  }
`

const NetworkStatusWLANsItemBase = css`
  width: 100%;
`

export const NetworkStatusWLANsItem = styled.div<{
  disabled?: boolean
}>`
  justify-content: start;
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  ${NetworkStatusWLANsItemBase};
  padding: ${theme.spacing.base};
  gap: ${theme.spacing.base};
  color: ${(p) => p.disabled && theme.colors.darkeyGrey};

  @media ${theme.devices.mobile} {
    flex-direction: column;
    gap: ${theme.spacing.xs};
  }
`

export const NetworkStatusWLANsIcon = styled.img`
  width: 52px;
  height: 38px;
  color: ${theme.colors.black};

  @media ${theme.devices.mobile} {
    width: 35px;
    gap: ${theme.spacing.xs};
    margin-left: -15px;
  }
`

export const NetworkStatusWLANsForwardIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.black};
`

export const NetworkStatusWLANsItemHeader = styled.div`
  font-weight: 900;
`

export const NetworkStatusWLANsCount = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  color: ${theme.colors.otterWarmBlack};
  font-size: 40px;
  font-weight: 900;
`

export const NetworkStatusWLANsCountLabel = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  margin-top: 15px;
  color: ${theme.colors.moreGrey};
  ${Font16};
`

export const NetworkStatusWLANsItemFooter = styled.div`
  ${Font14};
  display: flex;
  justify-content: flex-end;
  font-weight: 900;
`

export const NetworkStatusWLANsForwardButton = styled(CommonLinkButton)`
  display: flex;
  justify-content: flex-end;
  float: right;
`
